import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=52924622&"
import script from "./UserRoleTable.vue?vue&type=script&lang=js&"
export * from "./UserRoleTable.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VPagination,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52924622')) {
      api.createRecord('52924622', component.options)
    } else {
      api.reload('52924622', component.options)
    }
    module.hot.accept("./UserRoleTable.vue?vue&type=template&id=52924622&", function () {
      api.rerender('52924622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/UserRoleTable.vue"
export default component.exports